import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

@Component({
  selector: 'app-organization-members',
  templateUrl: './organization-members.component.html'
})
export class OrganizationMembersComponent {
  @Input() term: string;
  @Input() page: number;
  @Input() members: {
    items: null | Array<{}>;
    count: number;
    amountOfPages: number;
  };

  @Output() search = new EventEmitter<string>();
  @Output() setPage = new EventEmitter<number>();
  @Output() connect = new EventEmitter<number>();
  @Output() disconnect = new EventEmitter<number>();

  onSearch(searchTerm) {
    this.search.emit(searchTerm);
  }

  onSetPage(page: number) {
    this.setPage.emit(page);
  }

  onConnect(id: number) {
    this.connect.emit(id);
  }

  onDisconnect(id: number) {
    this.disconnect.emit(id);
  }
}
